<template>
  <div ref="mapHost" class="platform-map-host"></div>
</template>

<script lang="ts" setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { persistentMars3dMapEnabled, platformMapRuntime } from '/@/map-runtime/runtime'

const mapHost = ref<HTMLElement | null>(null)

onMounted(() => {
  if (persistentMars3dMapEnabled) platformMapRuntime.registerPersistentHost(mapHost.value)
})

onBeforeUnmount(() => {
  platformMapRuntime.registerPersistentHost(null)
  platformMapRuntime.destroy()
})
</script>

<style scoped>
.platform-map-host {
  position: fixed;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
  background: transparent;
}
</style>
